module.exports = __webpack_public_path__ + "img/caja-segura.6a2679c1.svg";